import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  NLPEntity,
  NLPPart,
  NLPParsing,
  NLPSentiment,
  NLPText,
  NLPkeyword,
  NLPCoreference,
  NLPLanguage,
  NLPVocabulary,
  NLPMessaging,
} from "../../../app-constants";

function Blockchaincustomsolutions() {
  return (
    <section className="blockchain_custom_solutions nlp_core_performance p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Core NLP We Add for <span>Superior Performance</span>
            </h2>
            <p>
              We are a credible blockchain app development company offering you
              unique blockchain solutions that are tailor-made to suit your
              business needs. Applying the concept of agility, we are keen on
              providing an in-depth understanding of your requirements. This
              approach allows us to grow unique partnerships that promote
              innovation and efficiency and advance your company’s digital
              leadership goals.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="block_custom_main">
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPEntity}</div>
                  <div className="block_custom_content">
                    <h5>Named Entity Recognition</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPPart}</div>
                  <div className="block_custom_content">
                    <h5>Part-of-Speech Tagging</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPParsing}</div>
                  <div className="block_custom_content">
                    <h5>Dependency Parsing</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPSentiment}</div>
                  <div className="block_custom_content">
                    <h5>Sentiment Analysis</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPText}</div>
                  <div className="block_custom_content">
                    <h5>Text Summarization</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPkeyword}</div>
                  <div className="block_custom_content">
                    <h5>Keyword Extraction</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPCoreference}</div>
                  <div className="block_custom_content">
                    <h5>Coreference Resolution</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPLanguage}</div>
                  <div className="block_custom_content">
                    <h5>Language Detection</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPVocabulary}</div>
                  <div className="block_custom_content">
                    <h5>Vocabulary Expansion</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{NLPMessaging}</div>
                  <div className="block_custom_content">
                    <h5>Personalized Messaging</h5>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Blockchaincustomsolutions;
